<template>
  <div>
    <div class="add_campaign_container">
      <section class="campaign_heading">
        <h2>{{ $t('CAMPAIGN.ADD_STEP.TITLE') }}</h2>
        <woot-button
          class=""
          icon="dismiss"
          variant="clear"
          color-scheme="secondary"
          @click="discardBroadcast"
        />
      </section>
      <section class="step_range_continer">
        <p>
          {{ step }}
          {{ $t('CAMPAIGN.ADD_STEP.RANGE_BAR.OF') }}
          {{ max_steps }}
          {{ $t('CAMPAIGN.ADD_STEP.RANGE_BAR.SELECT_TEXT') }}
        </p>
        <RangeInput
          id="range_step"
          :disabled="true"
          :min="0"
          :max="max_steps"
          :value="step"
        />
      </section>
      <!--
            <section v-if="step == 1">
            <ul class="campaign_types">
                <li v-for="item in types" class="campaign_type" :class="kind===item.value ? 'active_type':''" :key="item.title" @click="selectCampaignType(item)">
                    <div class="type_icon">
                        <div v-html="item.icon"></div>
                    </div>
                    <div class="type_body">
                        <h3 class="name">{{item.title}}</h3>
                        <p class="description">{{item.description}}</p>
                    </div>
                </li>
            </ul>
        </section>
        -->
      <section v-if="step == 1">
        <ul class="campaign_types">
          <CampaignTypeCard
            v-for="item in types"
            :key="item.title"
            :item="item"
            :is-active="kind === item.value"
            @onClick="selectCampaignType"
          />
        </ul>
      </section>
      <section v-if="step == 2">
        <!-- Audience filter logic -->
        <article>
          <section>
            <label
              class="field_label"
              :class="{ error: $v.appliedFilters.$error }"
            >
              {{ $t('CAMPAIGN.ADD_STEP.ONE_OFF.AUDIENCE_LABEL') }}
            </label>
            <div
              v-if="appliedFilters.length"
              class="medium-12 columns audience_filter"
            >
              <filter-input-box
                v-for="(filter, i) in appliedFilters"
                :key="i"
                v-model="appliedFilters[i]"
                :filter-groups="filterGroups"
                :grouped-filters="true"
                :input-type="getInputType(appliedFilters[i].attribute_key)"
                :operators="getOperators(appliedFilters[i].attribute_key)"
                :dropdown-values="
                  getDropdownValues(appliedFilters[i].attribute_key)
                "
                :show-query-operator="i !== appliedFilters.length - 1"
                :show-user-input="
                  showUserInput(appliedFilters[i].filter_operator)
                "
                :v="$v.appliedFilters.$each[i]"
                re-order-labels="false"
                @resetFilter="resetFilter(i, appliedFilters[i])"
                @removeFilter="removeFilter(i)"
              />
              <div class="filter-actions mt-4">
                <woot-button
                  icon="add"
                  class="add_campaign_filter"
                  color-scheme="primary"
                  variant="clear"
                  size="small"
                  @click="appendNewFilter"
                >
                  {{ $t('CONTACTS_FILTER.ADD_NEW_FILTER') }}
                </woot-button>
              </div>
            </div>
          </section>
        </article>

        <!-- days type filter group kind=repeat -->
        <section v-if="kind === 'repeat'">
          <!-- <label :class="{ error: $v.appliedFilters.$error }"> -->
          <label :class="{ error: $v.campaign_repeat_at.$error }">
            {{ $t('CAMPAIGN.ADD.FORM.AUDIENCE.CUSTOM_LABEL') }}
          </label>
          <div class="medium-12 columns audience_filter">
            <filter-input-box
              v-for="(filter, i) in [appliedFilters[0]]"
              :key="i"
              v-model="campaign_repeat_at"
              re-order-labels="true"
              :filter-groups="onGoingDateFilterGroups"
              :grouped-filters="true"
              input-type=""
              :operators="onGoingOperators"
              :dropdown-values="
                getDropdownValues(appliedFilters[i].attribute_key)
              "
              :show-query-operator="false"
              :show-user-input="
                showUserInput(appliedFilters[i].filter_operator) ? true : true
              "
              :v="$v.campaign_repeat_at"
            />
            <!-- :v="$v.appliedFilters.$each[i]" -->
          </div>
        </section>

        <!-- schedule time Day selector when type=repeat  -->
        <label
          v-if="kind === 'repeat'"
          class="add_camp_calendar"
          :class="{ error: $v.scheduledAt.$error }"
        >
          {{ $t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.LABEL') }}
          <woot-date-time-picker
            display-format="HH:mm"
            :value="scheduledAt"
            :disable-dates="0"
            :confirm-text="$t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.CONFIRM')"
            :placeholder="$t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.PLACEHOLDER')"
            :type="'time'"
            @change="onChange"
          />
          <p v-if="$v.scheduledAt.$error" class="message">
            {{
              $t(
                'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.ADD.SCHEDULED_AT.ERROR'
              )
            }}
          </p>
        </label>

        <!-- Schedule time date selector -->
        <article
          v-if="kind === 'call'"
          class="add_camp_calendar"
          :class="{ error: $v.scheduledAt.$error }"
        >
          <label class="field_label">
            {{ $t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.LABEL') }}
          </label>
          <woot-date-time-picker
            display-format="D MMM YYYY HH:mm:ss"
            :value="scheduledAt"
            style="margin-top:'8px'"
            :disable-dates="0"
            :confirm-text="$t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.CONFIRM')"
            :placeholder="$t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.PLACEHOLDER')"
            @change="onChange"
          />
          <p v-if="$v.scheduledAt.$error" class="message">
            {{
              $t(
                'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.ADD.SCHEDULED_AT.ERROR'
              )
            }}
          </p>
        </article>
        <AudienceAndTopupAiBroadcast
          v-if="eligible_audience.isFetched"
          :eligible_audience="eligible_audience"
        />
      </section>
      <section v-if="step == 3">
        <!-- <article :class="{ error: $v.selectedAssistant.$error }">
                <div class="font_regular text_12 font_500">
                    {{ $t('CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.ADD.ASSISTANT.TITLE') }}
                </div>
                <select
                    v-model="selectedAssistant"
                    class="font_regular text_14 font_500"
                    style="margin-top:8px;"
                >
                      <option disabled :value="null">{{ $t('CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.ADD.ASSISTANT.PLACEHOLDER') }}</option>
                    <option v-for="item in LLMAssistants" :key="item.name" :value="item">{{ item.name }}</option>
                </select>
                <span
                    v-if="$v.selectedAssistant.$error"
                    class="message"
                >{{ $t('CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.ADD.ASSISTANT.ERROR') }}</span>
            </article> -->
        <MultiselectDropdown
          :label="
            $t('CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.ADD.ASSISTANT.TITLE')
          "
          :error="
            $v.selectedAssistant.$error
              ? $t('CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.ADD.ASSISTANT.ERROR')
              : ''
          "
        >
          <multiselect
            class="column small-12"
            v-model="selectedAssistant"
            :options="LLMAssistants"
            track-by="id"
            label="name"
            :multiple="false"
            :close-on-select="true"
            :clear-on-select="false"
            :hide-selected="false"
            :placeholder="
              $t(
                'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.ADD.ASSISTANT.PLACEHOLDER'
              )
            "
            selected-label
            :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
            :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
            :maxHeight="200"
          />
        </MultiselectDropdown>

        <div
          class="campaint_title_wrap"
          :class="{ cann_margin: !$v.title.$error }"
        >
          <woot-input
            v-model="title"
            :label="$t('CAMPAIGN.ADD.FORM.TITLE.LABEL')"
            type="text"
            class="campaign_title  font_500 text_12"
            :class="{ error: $v.title.$error }"
            :error="$v.title.$error ? $t('CAMPAIGN.ADD.FORM.TITLE.ERROR') : ''"
            :placeholder="$t('CAMPAIGN.ADD.FORM.TITLE.PLACEHOLDER')"
            @blur="$v.title.$touch"
          />
          <p v-if="!$v.title.$error" class="campaign_title_note">
            {{ $t('CAMPAIGN.ADD.FORM.TITLE.NOTE') }}
          </p>
        </div>
      </section>

      <section class="campaign_btns">
        <woot-button
          class="campaign_btn"
          :is-disabled="isDisableBackBtn"
          variant="clear"
          @click="handleBack"
        >
          {{ $t('CAMPAIGN.ADD_STEP.BTNS.BACK') }}
        </woot-button>
        <woot-button
          class="campaign_btn campaign_btn_solid"
          :is-disabled="isDisableNextBtn || uiFlagsLLMAssistants.isLLMFetching"
          :is-loading="uiFlagsLLMAssistants.isLLMFetching"
          @click="handleNext"
        >
          {{ $t('CAMPAIGN.ADD_STEP.BTNS.NEXT') }}
        </woot-button>
      </section>
    </div>
    <AiBroadcastPreviewModal
      :is-open="isPreviewPopupOpen"
      :on-close="hidePreviewPopup"
      :types="types"
      :kind="kind"
      :prefilapplied-filters="appliedFilters"
      :scheduled-at="scheduledAt"
      :selected-assistant="selectedAssistant"
      :title="title"
      :campaign_repeat_at="campaign_repeat_at"
      :on-going-operators="onGoingOperators"
      @onSave="onSave"
    />
    <DiscardAddAIBroadcast
      v-if="isDiscardOpen"
      :is-open="isDiscardOpen"
      :title="$t('CAMPAIGN.ADD_STEP.DISCARD_MODAL.TITLE')"
      :description="$t('CAMPAIGN.ADD_STEP.DISCARD_MODAL.DESCRIPTION')"
      :yes-label="$t('CAMPAIGN.ADD_STEP.DISCARD_MODAL.YES_BTN')"
      :no-label="$t('CAMPAIGN.ADD_STEP.DISCARD_MODAL.NO_BTN')"
      @onClose="closeDiscardBroadcast"
      @onYes="onDiscardBroadcast"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { required, requiredIf } from 'vuelidate/lib/validators';
import alertMixin from 'shared/mixins/alertMixin';
import campaignMixin from 'shared/mixins/campaignMixin';
import filterMixin from 'shared/mixins/filterMixin';
import { mixin as clickaway } from 'vue-clickaway';
import DiscardAddAIBroadcast from './DiscardAddAIBroadcast.vue';
import RangeInput from 'components/ui/RangeInput.vue';
import { svgIcons } from '../../../../../../shared/components/FluentIcon/svg_icons';
import FilterInputBox from 'components/widgets/FilterInput/Index.vue';
import contactFilterItems, {
  filterAttributeGroups,
} from '../../../contacts/contactFilterItems/index';
import countries from '../../../../../../shared/constants/countries';
import * as OPERATORS from '../../../../../components/widgets/FilterInput/FilterOperatorTypes';
import WootDateTimePicker from 'dashboard/components/ui/DateTimePicker.vue';
import AiBroadcastPreviewModal from './AiBroadcastPreviewModal.vue';
import filterQueryGenerator from '../../../../../helper/filterQueryGenerator';
import AudienceAndTopupAiBroadcast from './AudienceAndTopupAiBroadcast.vue';
import CampaignAgentsApi from 'dashboard/api/campaign_agents';
import MultiselectDropdown from 'components/ui/inputs/MultiselectDropdown.vue';
import CampaignTypeCard from './CampaignTypeCard.vue';

export default {
  components: {
    FilterInputBox,
    RangeInput,
    WootDateTimePicker,
    DiscardAddAIBroadcast,
    AiBroadcastPreviewModal,
    AudienceAndTopupAiBroadcast,
    MultiselectDropdown,
    CampaignTypeCard,
  },
  mixins: [alertMixin, campaignMixin, filterMixin, clickaway],
  data() {
    return {
      isPreviewPopupOpen: false,
      isDiscardOpen: false,
      title: '',
      step: 1,
      max_steps: 3,
      types: [
        // make a separate file for custom svgs and render as v-html
        {
          value: 'call',
          title: this.$t(
            'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.ADD.KIND.CALL_TITLE'
          ),
          description: this.$t(
            'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.ADD.KIND.CALL_DESC'
          ),
          icon: svgIcons.oneOff({ height: 60, width: 60 }),
        },
        {
          value: 'repeat',
          title: this.$t(
            'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.ADD.KIND.RUNNING_TITLE'
          ),
          description: this.$t(
            'CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.ADD.KIND.RUNNING_DESC'
          ),
          icon: svgIcons.repeat({ height: 60, width: 60 }),
        },
      ],
      appliedFilters: [],
      filterGroups: [],
      filterTypes: contactFilterItems.map(filter => ({
        ...filter,
        attributeName: this.$t(
          `CONTACTS_FILTER.ATTRIBUTES.${filter.attributeI18nKey}`
        ),
      })),
      filterAttributeGroups,
      attributeModel: 'contact_attribute',
      filtersFori18n: 'CONTACTS_FILTER',
      scheduledAt: null,
      selectedAssistant: null,
      campaign_repeat_at: {},
      kind: 'call', // call or chat // everything is call, no chat

      // prefill states
      onGoingDateFilterGroups: [],
      eligible_audience: {
        audience: 0,
        // costs: 0,
        // max_audience: 0,
        // available_credit: 0,
        isFetched: false,
        // isAllowModify: false,
      },
      onGoingOperators: [
        { label: '', value: 'equal_to' },
        { label: '', value: 'is_greater_than' },
        { label: '', value: 'is_lesser_than' },
      ],
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      getAppliedContactFilters: 'contacts/getAppliedContactFilters',
      contactStatus: 'accounts/getContactStatus',
      LLMAssistants: 'llmbots/getLLMAssistants',
      uiFlagsLLMAssistants: 'llmbots/getUIFlags',
    }),
    isDisableBackBtn() {
      if (!this.kind || this.step === 1) {
        return true;
      }
      return false;
    },
    isDisableNextBtn() {
      // step 1: is campaign seleted
      if (!this.kind) {
        return true;
      }

      return false;
    },
  },
  watch: {
    campaign_repeat_at(newRepeatAt) {
      if (newRepeatAt.filter_operator === 'equal_to') {
        this.campaign_repeat_at.values = 0;
      }
    },
  },
  async mounted() {
    // await this.$store.dispatch("llmbots/fetchLLMAssistants");
    await this.$store.dispatch('llmbots/fetchLLMAssistants', {
      kind: this.kind,
    });
    // set all the intitial values
    this.setInitialStates();
    // this.$store.dispatch('attributes/get');
    this.setFilterAttributes();
    // sent contact filters
    if (this.getAppliedContactFilters.length) {
      this.appliedFilters = [...this.getAppliedContactFilters];
    } else {
      this.appliedFilters.push({
        attribute_key: 'name',
        filter_operator: 'equal_to',
        values: '',
        query_operator: 'and',
        attribute_model: 'standard',
      });
    }
  },
  validations() {
    const commonValidations = {
      title: {
        required,
      },
      scheduledAt: {
        required,
      },
      // selectedInbox: {
      //     required,
      // },
      selectedAssistant: {
        required,
      },
      appliedFilters: {
        required,
        $each: {
          values: {
            required: requiredIf(prop => {
              return !(
                prop.filter_operator === 'is_present' ||
                prop.filter_operator === 'is_not_present'
              );
            }),
          },
        },
      },
      campaign_repeat_at: {
        required: false,
        values: {
          // wrong to bypass the validation error to match component need
          required: false,
        },
      },
    };

    return {
      ...commonValidations,
    };
  },
  methods: {
    async onSave() {
      try {
        const payload = {
          name: this.title,
          llm_chatbot_id: this.selectedAssistant?.id,
          account_id: this.currentUser.account_id,
          kind: this.kind,
          inbox_id: null, // leave this blank also can //
          scheduled_at: this.scheduledAt,
          // trigger_rules: {},
          audience: filterQueryGenerator(this.appliedFilters).payload,
          // "parent_id": null,
          // assistant_id: this.selectedAssistant,
        };
        if (this.kind === 'repeat') {
          payload.trigger_rules = {
            filter_operator: this.campaign_repeat_at.filter_operator,
            values: this.campaign_repeat_at.values,
            attribute_key: this.campaign_repeat_at.attribute_key,
          };
        }

        await this.$store.dispatch(
          'campaign_agents/createCampaignAgent',
          payload
        );
        this.hidePreviewPopup();
        this.showAlert(this.$t('CAMPAIGN.ADD.API.SUCCESS_MESSAGE'));
        this.onDiscardBroadcast();
      } catch (error) {
        console.log(error, error?.response);
        this.showErrAlert(error, this.$t('CAMPAIGN.ADD.API.ERROR_MESSAGE'));
      }
    },
    async setInitialStates() {
      let allCustomAttributes = this.$store.getters[
        'attributes/getAttributesByModel'
      ](this.attributeModel);
      if (allCustomAttributes.length) {
        await this.$store.dispatch('attributes/get');
      }
      await this.$nextTick();
      this.setFilterAttributes();

      // call to get 'date' type attribute filter group
      try {
        this.getTimeFilterGroup();
        // set the intial campaign repeat
        if (this.onGoingDateFilterGroups.length) {
          // this.campaign_repeat_at = this.onGoingDateFilterGroups[0];
          if (this.onGoingDateFilterGroups[0].attributes?.length) {
            this.campaign_repeat_at = {
              filter_operator: 'equal_to',
              values: 0,
              attribute_key: this.onGoingDateFilterGroups[0].attributes[0].key,
            };
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async selectCampaignType(typeEl) {
      this.kind = typeEl.value;
      // this.$store.dispatch('llmbots/fetchLLMBots',{kind:typeEl.value});
    },
    async handleNext() {
      // vaildate the form
      switch (this.step) {
        case 1:
          this.step += 1;
          break;
        case 2:
          this.$v.appliedFilters.$touch();
          this.$v.scheduledAt.$touch();
          if (this.$v.appliedFilters.$error || this.$v.scheduledAt.$error) {
            console.error('Applied filters are invalid');
            return false;
          }
          if (!this.eligible_audience.isFetched) {
            // check eligible audience before showing preview once
            await this.checkEligibleAudience();
            return false;
          }
          this.step += 1;
          break;
        case 3:
          this.$v.title.$touch();
          this.$v.selectedAssistant.$touch();
          if (this.$v.title.$error || this.$v.selectedAssistant.$error) {
            console.error('Validation error', this.$v);
            return false;
          }
          // open preview modal as last step
          this.showPreviewPopup();
          break;

        default:
          break;
      }

      return true;
    },
    handleBack() {
      // if step 3, clear select inbox
      if (this.step === 2) {
        // clear inbox if user go back
        // this.selectedInbox = null;
        this.eligible_audience.isFetched = false;
        // this.eligible_audience.isAllowModify = false;
      }
      this.step -= 1;
    },
    getInputType(key) {
      const type = this.filterTypes.find(filter => filter.attributeKey === key);
      return type.inputType;
    },
    getOperators(key) {
      const type = this.filterTypes.find(filter => filter.attributeKey === key);
      return type.filterOperators;
    },
    getDropdownValues(type) {
      switch (type) {
        case 'country_code':
          return countries;
        case 'status_id':
          return this.contactStatus;
        default:
          return undefined;
      }
    },
    showUserInput(operatorType) {
      return !(
        operatorType === 'is_present' || operatorType === 'is_not_present'
      );
    },
    resetFilter(index, currentFilter) {
      this.appliedFilters[index].filter_operator = this.filterTypes.find(
        filter => filter.attributeKey === currentFilter.attribute_key
      ).filterOperators[0].value;
      this.appliedFilters[index].values = '';
    },
    removeFilter(index) {
      if (this.appliedFilters.length <= 1) {
        this.showAlert(this.$t('CONTACTS_FILTER.FILTER_DELETE_ERROR'));
      } else {
        this.appliedFilters.splice(index, 1);
      }
    },
    appendNewFilter() {
      this.appliedFilters.push({
        attribute_key: 'name',
        filter_operator: 'equal_to',
        values: '',
        query_operator: 'and',
      });
    },
    customAttributeInputType(key) {
      switch (key) {
        case 'date':
          return 'date';
        default:
          return 'plain_text';
      }
    },
    getOperatorTypes(key) {
      switch (key) {
        case 'list':
          return OPERATORS.OPERATOR_TYPES_1;
        case 'text':
          return OPERATORS.OPERATOR_TYPES_3;
        case 'number':
          return OPERATORS.OPERATOR_TYPES_1;
        case 'link':
          return OPERATORS.OPERATOR_TYPES_1;
        case 'date':
          return OPERATORS.OPERATOR_TYPES_4;
        case 'checkbox':
          return OPERATORS.OPERATOR_TYPES_1;
        default:
          return OPERATORS.OPERATOR_TYPES_1;
      }
    },
    onChange(value) {
      this.scheduledAt = value;
    },
    showPreviewPopup() {
      this.isPreviewPopupOpen = true;
    },
    hidePreviewPopup() {
      this.isPreviewPopupOpen = false;
    },
    discardBroadcast() {
      this.isDiscardOpen = true;
    },
    closeDiscardBroadcast() {
      this.isDiscardOpen = false;
    },
    onDiscardBroadcast() {
      // clear fields
      this.closeDiscardBroadcast();
      this.clearForm();
      this.$router.push(
        `/app/accounts/${this.currentUser.account_id}/campaigns/aiBroadcast`
      );
    },
    clearForm() {
      this.$v.$reset();
      this.step = 1;
      this.appliedFilters = [
        {
          attribute_key: 'name',
          filter_operator: 'equal_to',
          values: '',
          query_operator: 'and',
          attribute_model: 'standard',
        },
      ];
      this.scheduledAt = null;
      this.title = '';
      this.selectedAssistant = null;
    },
    getTimeFilterGroup() {
      let allCustomAttributes = this.$store.getters[
        'attributes/getAttributesByModel'
      ](this.attributeModel);

      const customAttributesFormattedForDate = {
        name: this.$t(`${this.filtersFori18n}.GROUPS.CUSTOM_ATTRIBUTES`),
        attributes: allCustomAttributes
          .map(attr => {
            return {
              key: attr.attribute_key,
              name: attr.attribute_display_name,
              attribute_display_type: attr.attribute_display_type,
            };
          })
          .filter(attrDate => attrDate.attribute_display_type === 'date'),
      };

      const filterGroupsDate = [customAttributesFormattedForDate];

      this.onGoingDateFilterGroups = filterGroupsDate;
    },
    async checkEligibleAudience() {
      try {
        const { data } = await CampaignAgentsApi.checkEligibleAudience({
          account_id: this.currentUser.account_id,
          campaign_agent: {
            audience: filterQueryGenerator(this.appliedFilters).payload,
            scheduled_at: this.scheduledAt,
          },
        });
        this.eligible_audience = {
          audience: data.audience,
          isFetched: true,
        };
      } catch (error) {
        console.error(
          'Error checking eligible audience',
          error,
          error?.response
        );
        this.showErrAlert(error, 'Something went wrong!');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_fonts.scss';
.common_font {
  font-family: 'Figtree', sans-serif;
  line-height: 1.4;
  color: #1f1f1f;
}

.add_campaign_container {
  max-width: 640px;
  margin: auto;
  margin-top: 32px;
}
.campaign_heading {
  display: flex;
  align-items: center;
  justify-content: space-between;

  h2 {
    font-weight: 600;
    font-size: 20px;
    line-height: 1.4;
    font-family: 'Figtree';
    color: #1f1f1f;
  }
}

.step_range_continer {
  margin-top: 16px;
  margin-bottom: 32px;
  p {
    font-weight: 500;
    font-size: 14px;
    line-height: 1.4;
    font-family: 'Figtree';
    color: #1f1f1f;
  }
}
.step_container {
  max-width: 90%;
  @media (max-width: 768px) {
    // Mobile
    max-width: 100%;
  }
}
.campaign_btns {
  display: flex;
  gap: 16px;
  margin-top: 32px;
  .campaign_btn {
    width: 280px;
  }
  .campaign_btn_solid {
    background-color: #8d25f6 !important;
  }
}
.campaign_types {
  display: flex;
  gap: 12px;
  list-style: none;
  margin-top: 24px;
}
/*
.campaign_type{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-items: center;
    justify-content: center;
    width: 280px;
    height: 240px;
    border: 1px solid #EEEEEE;
    border-radius: 10px;
    padding: 20px;
    margin: 24px 0 0 0;
    cursor: pointer;
    transition:  all ease-in-out 0.2s;

    .type_body{
        margin-top: 16px;
        text-align: center;
        .name{
            @extend .common_font;
            font-weight: 600;
            font-size: 16px;
            color: #000;
        }
        .description{
            @extend .common_font;
            font-weight: 500;
            font-size: 14px;
            color:#858585;
            margin-top: 4px;
        }
    }
}
.active_type{
    border: 2px solid #8D25F6;
    transition:  all ease-in-out 0.2s;
}
*/
.field_label {
  @extend .common_font;
  font-weight: 500;
  font-size: 12px;
  margin-top: 16px;
  margin-bottom: 8px;
}
.audience_filter {
  margin-bottom: 8px;
}
.campaint_title_wrap {
  position: relative;
}
</style>

<style>
.audience_filter .filters .filter {
  padding: 0;
  border: none;
  background-color: #fff;
}
.audience_filter .filters .filter .filter-inputs .filter__question,
.audience_filter .filters .filter .filter-inputs .filter__operator {
  margin-right: 12px;
}

.add_campaign_filter svg,
.add_campaign_filter .button__content {
  font-family: 'Figtree', sans-serif;
  line-height: 1.4;
  font-weight: 600;
  font-size: 14px;
  color: #8d25f6;
}
.add_campaign_filter:hover .button__content {
  color: inherit;
}

.cann_margin {
  margin-bottom: 25px;
}

.add_camp_calendar input {
  font-size: 14px;
}

.add_campaign_container input,
.add_campaign_container select,
.add_campaign_container option {
  font-family: 'Figtree', sans-serif !important;
  font-size: 14px !important;
  color: #1f1f1f !important;
  /* color: #858585 !important; */
}

.add_campaign_container .date-picker {
  margin: 0;
}
</style>
